

Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.View = (function () {

    function DataImportView() {

        this.entityPicklist = new Greenmile.DataImport.EntityList();
        this.uploadFile = new Greenmile.DataImport.UploadFile();
        this.lateralMenu = new Greenmile.DataImport.LateralMenu(this);
        this.processingStatus = new Greenmile.DataImport.ProcessingStatus();
        App.Forms.DataImport.EntityList = this.entityPicklist;

        this.createBaseStructure = function() {

            this.rootEl = document.createElement('div');
            this.rootEl.id ='dataImporterContainer';

        };

        this.clearUploadStatus = function() {
            var divStatus = document.querySelector(".uploadFile"),
                message = divStatus.querySelector('.uploadMessages'),
                icon = divStatus.querySelector('.uploadImage');

            icon.className = 'uploadImage';
            message.innerHTML = '';
        };

        this.render = function() {

            this.createBaseStructure();

            var container = document.createElement('div');
            var contentContainer = document.createElement('div');
            var formContainer = document.createElement('div');
            var progress = document.createElement('div');
            var errorContainer = document.createElement('div');

            container.className = 'data-container';
            contentContainer.className = 'contentContainer';
            formContainer.className = 'form_DataImport';
            progress.className = 'progressContainer';

            errorContainer.className ='monetInlineAlerContainer';

            progress.appendChild(this.processingStatus.render());

            this.entityPicklist.render();
            formContainer.appendChild(this.uploadFile.render(this));

            contentContainer.appendChild(errorContainer);
            contentContainer.appendChild(formContainer);
            contentContainer.appendChild(progress);

            container.appendChild(this.lateralMenu.render());
            container.appendChild(contentContainer);

            this.rootEl.appendChild(container);

            return this.rootEl;
        };
    }

    return DataImportView;
}());